import { Card, Skeleton } from 'antd';
import React, { forwardRef } from 'react';

const CommonCard = forwardRef((props) => {
  const { children, loading, skeletonRows = 5, cardRef, ...rest } = props;
  return (
    <Card {...rest} ref={cardRef}>
      {loading ? (
        <Skeleton active paragraph={{ rows: skeletonRows }} />
      ) : (
        children
      )}
    </Card>
  );
});

export default CommonCard;
